import '../assets/styles/Recomendacoes.css';
import Card from './Card';
import foto1 from '../assets/images/recomendacao1.jpg';
import foto2 from '../assets/images/recomendacao2.jpg';
import foto3 from '../assets/images/recomendacao3.jpg';

export default function Recomendacoes() {
    return (
        <section className="recomendacoes">
            <div className="recomendacoes-container">
                <h2>O que nossos clientes dizem</h2>
                <div className="cards-container">
                    <Card 
                        texto="Estou extremamente satisfeita com o Serviço! Instalaram meu chuveiro e novas tomadas. Recomendo"
                        foto={foto1}
                        nome="Neide Santos"
                    />
                    <Card 
                        texto="Uau! Me salvaram a vida, serviço rápido e limpo. Obrigado ifix pelos serviços."
                        foto={foto2}
                        nome="Arthur Oliveira"
                    />
                    <Card 
                        texto="A i'fix fez um trabalho incrível na reforma do meu banheiro. Profissionais qualificados, pontuais e muito atenciosos. Com certeza vou contratar novamente!"
                        foto={foto3}
                        nome="Laura Silva"
                    />
                </div>
            </div>
        </section>
    );
}